import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'orderOnline',
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageRefundOrder`, queryParam)
  },
  getImportPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageOfflineRefund`, queryParam)
  },
  handleOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/handleRefundApply`, queryParam)
  },
  getOrderPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageRefundApply`, queryParam)
  },
  getCalcRefundOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/calcRefundOrder`, queryParam)
  },
  getCalcOfflineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/calcOfflineRefund`, queryParam)
  },
  musicbasisExportOnlineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportOfflineRefund`, queryParam)
  },
  musicbasisExportOfflineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportOnlineRefund`, queryParam)
  },
}
